import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/axiosInstance";
import Button from "./Button";

const LogoutButton = ({ onLogout, size = "sm" }) => {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);
  const [busy, setBusy] = useState(false);

  const handleLogout = async () => {
    setBusy(true);
    try {
      await api.post("auth/logout");
      setUser(null);
      // Lets whoever opened the confirmation close it and drop its own state.
      onLogout?.();
      navigate("/");
    } catch (err) {
      console.error("Logout failed", err);
      setBusy(false);
    }
  };

  return (
    <Button variant="danger" size={size} onClick={handleLogout} disabled={busy}>
      {busy ? "Logging out..." : "Log out"}
    </Button>
  );
};

export default LogoutButton;
